// PLAN-cockpit-v2-iter1 Phase 6: 折り畳み可能な facet group
// 各 group の開閉状態は localStorage に永続化 (key prefix: cockpit_v2.facet_open.)
import { useCallback, useEffect, useState, type ReactNode } from 'react'

const STORAGE_PREFIX = 'cockpit_v2.facet_open.'

interface Props {
  id: string                  // localStorage key suffix (group ごとに一意)
  label: string               // 見出し
  count?: number              // 件数バッジ (省略可)
  defaultOpen?: boolean
  children: ReactNode
}

function readOpen(id: string, defaultOpen: boolean): boolean {
  try {
    const v = window.localStorage.getItem(STORAGE_PREFIX + id)
    if (v === null) return defaultOpen
    return v === '1'
  } catch { return defaultOpen }
}

export function FacetGroup({ id, label, count, defaultOpen = true, children }: Props) {
  const [open, setOpen] = useState<boolean>(() => readOpen(id, defaultOpen))

  const toggle = useCallback(() => {
    setOpen(prev => {
      const next = !prev
      try { window.localStorage.setItem(STORAGE_PREFIX + id, next ? '1' : '0') } catch { /* ignore */ }
      return next
    })
  }, [id])

  // id 変更時に再読込
  useEffect(() => {
    setOpen(readOpen(id, defaultOpen))
  }, [id, defaultOpen])

  return (
    <div className="border-t border-border-subtle first:border-t-0">
      <button type="button"
        onClick={toggle}
        aria-expanded={open}
        className="w-full flex items-center justify-between py-2 px-0.5 text-xs uppercase tracking-wide text-text-subtle hover:text-text-base">
        <span className="flex items-center gap-2">
          <span aria-hidden className="inline-block w-3 text-center transition-transform" style={{ transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}>▸</span>
          {label}
          {typeof count === 'number' && count > 0 && (
            <span className="text-[10px] text-text-subtle font-mono">({count})</span>
          )}
        </span>
      </button>
      {open && <div className="pb-3">{children}</div>}
    </div>
  )
}
